export const CLOUD_ACCOUNT = {
  AWS: "aws",
  AZURE: "azure",
  GCP: "gcp",
  IBM: "ibm",
  VMW: "vmw",
};
